import { createContext, type PropsWithChildren, useContext } from "react";

export type FilterProviderValue = Partial<Record<string, string | string[] | number | undefined>>;
export type FilterProviderOnChange = (values: FilterProviderValue) => void;

type ContextType = { value: FilterProviderValue; onChange: FilterProviderOnChange };

const Context = createContext({ value: {}, onChange: () => {} } as ContextType);

interface Props extends PropsWithChildren {
  value: FilterProviderValue;
  onChange: FilterProviderOnChange;
}

export function FilterProvider({ value, onChange, children }: Props) {
  return <Context.Provider value={{ value, onChange }}>{children}</Context.Provider>;
}

export function useFilterContext() {
  return useContext(Context);
}
